import React from "react";

export default function PageHeader({ title, right }) {
  return (
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h5>{title}</h5>
      {right}
    </div>
  );
}
